import { SplitButton } from '../../buttons';
import styled from 'styled-components6';
import { When } from 'react-if';
import { useReview } from '../../../fetchers/ReviewFetcher/ReviewFetcher';
import { useJob } from '../../../fetchers';

const PaneButton = styled(SplitButton).withConfig({
    shouldForwardProp: (prop) => prop !== 'isSelected',
})<{
    isSelected: boolean;
}>`
    padding: var(--rwl-spacing-md) var(--rwl-spacing-lg);
    border-bottom: ${({ isSelected }) =>
        isSelected
            ? '2px solid var(--rwl-text-default)'
            : '2px solid transparent'};
    color: ${({ isSelected }) =>
        isSelected ? 'var(--rwl-text-default)' : 'var(--rwl-palette-gray-600)'};
    font-weight: 600;
`;

interface PaneButtonsProps {
    onClick: (pane: 'description' | 'review') => void;
    selectedPane: 'description' | 'review';
}

export const PaneButtons = ({ onClick, selectedPane }: PaneButtonsProps) => {
    const { review } = useReview();
    const { job } = useJob();
    return (
        <When condition={!!review && !!job}>
            <div style={{ display: 'flex' }}>
                {/* Only show the buttons if there is a review since we default to the description */}
                <PaneButton
                    isSelected={selectedPane === 'description'}
                    fullWidth={false}
                    onClick={() => onClick('description')}
                >
                    Description
                </PaneButton>
                <PaneButton
                    isSelected={selectedPane === 'review'}
                    fullWidth={false}
                    onClick={() => onClick('review')}
                >
                    Review
                </PaneButton>
            </div>
        </When>
    );
};
